<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Down Cow / Metabolic Issues
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Interested in Agvance transition salts?</dt>
          <dd>{{ model.wants_agvance_transition_salts || '-' }}</dd>
        </dl>
      </div>

      <div class="text-left step-section">
        <h3 class="text-left" :class="isRemovedSubsection('down_cow_products_purchased') ? 'subsection-disabled' : ''">
          <u>Down cow products purchased</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'down_cow_products_purchased')">
            <span class="glyphicon" :class="isRemovedSubsection('down_cow_products_purchased') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dcp, index) in model.CHARTS.downcow_products" :key="index"
              :class="getRowClass(model.CHARTS.downcow_products, 'Season', index)">

              <td class="text-left">{{ dcp["Season"] }}</td>
              <td class="text-left">{{ dcp["Product"] }}</td>
              <td class="text-left">{{ dcp["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.downcow_meta_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.downcow_meta_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  props: ['model'],
  data() {
    return {
      stepName: 'DownCowMeta',
    }
  },
};
</script>
